// Bootstrap
import 'bootstrap'

// NPM dependencies
import Slideout from 'slideout'
import WebFont from 'webfontloader'
import 'jquery-hoverintent'
import SmoothScroll from 'smooth-scroll'

// init slideout.js
const slideout = new Slideout({
  'panel': document.getElementById('slideout-panel'),
  'menu': document.getElementById('slideout-menu'),
  'padding': 256,
  'tolerance': 70
});

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        $('body').removeClass('no-js')
        // JavaScript to be fired on all pages

        WebFont.load({
          google: {
            families: ['Open Sans:300,300italic,600,600italic', 'Volkhov:700']
          }
        })

        var toggleHover = function () {
          $(this).toggleClass('hoverIntent')
        }
        $('.nav-primary > ul > li').hoverIntent(toggleHover)

        // Toggle button
        $('.slideout-toggle-button').on('click', function () {
          slideout.toggle()
          $('.hamburger').toggleClass('is-active')
          $('#slideout-panel').toggleClass('is-inactive')
        })

        $(window).scroll(function () {
          // console.log($('header').offset().top);
          if ($('header').offset().top > 200) {
            $('body').addClass('is_scrolled')
          } else if ($('header').offset().top === 0) {
            $('body').removeClass('is_scrolled')
          }
        })
      },
      finalize: function () {}
      // JavaScript to be fired on all pages, after page specific JS is fired
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'contact': {
      init: function () {
        // JavaScript to be fired on the about us page
        document.addEventListener('wpcf7mailsent', function (event) {
          window.location = '/thank-you/'
        }, false)
      }
    },
    'page_template_sections': {
      init: function () {
        $('body').scrollspy({ target: 'body', offset: 100 })
        var scroll = new SmoothScroll('a[href*="#"]')
      }
    }
  }

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire
      var namespace = Sage
      funcname = (funcname === undefined) ? 'init' : funcname
      fire = func !== ''
      fire = fire && namespace[func]
      fire = fire && typeof namespace[func][funcname] === 'function'

      if (fire) {
        namespace[func][funcname](args)
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common')

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm)
        UTIL.fire(classnm, 'finalize')
      })

      // Fire common finalize JS
      UTIL.fire('common', 'finalize')
    }
  }

  // Load Events
  $(document).ready(UTIL.loadEvents)
})(jQuery) // Fully reference jQuery after this point.



// WEBPACK FOOTER //
// ./assets/scripts/main.js